import React from 'react'
import { string, object } from 'prop-types'

class LocProductList extends React.Component {

  getProductData() {
    const { data } = this.props
    const output = [ ]

    Object.keys(data).map(key => {
      const item = data[key]
      if (!item.prodlib) return
      let {
        name
      } = item.prodlib

      const productName = item.title || name
      const title = item.browserTitle ? item.browserTitle : productName
      const link = item.links && item.links['reviews'] ? item.links['reviews'] + '.html' : ''
      let starRatingOutput = ''
      for (let i = 0; i < item.score['averageAsInteger']; i++) {
        starRatingOutput += '★'
      }

      output.push({
        productName,
        code: item.baseProduct,
        reviewLink: link,
        title,
        reviewed: item.score['reviewed'],
        score: ' '+ Math.round(item.score['average']*2) + '/10 ',
        starRating: item.score['averageAsInteger'],
        starRatingOutput
      })
      return item
    })
    return output
  }

  makeRowData( rowData ){
    return rowData.map((row, key) => {
      if (!row.productName || !row.reviewed ) return null
      if (!row.productName.toLowerCase().indexOf('mystery')) return null
      const productName = row.productName + ' reviews'
      return (
        <div key={key}>
          <p>
            { row.reviewLink ? (
              <a href={row.reviewLink} title={row.title}>{ productName }</a>
            ) : ( productName ) }
            { row.score }
            { row.starRating && (
              <span className='bold stars'> { row.starRatingOutput }</span>
            )}
          </p>
        </div>
      )
    })
  }

  render () {
    const { id } = this.props
    const rowData = this.getProductData()
    const makeRow = this.makeRowData( rowData )
    return (
      <div className='hidden showAMP' id={id} aria-expanded='true'>
        <div className='panel-body'>
          {makeRow}
        </div>
      </div>
    )
  }
}

LocProductList.propTypes = {
  data: object,
  id: string
}

export default LocProductList



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/locProductList.jsx